import { render, staticRenderFns } from "./DataVisual.vue?vue&type=template&id=2d10ac88&scoped=true"
import script from "./DataVisual.vue?vue&type=script&lang=js"
export * from "./DataVisual.vue?vue&type=script&lang=js"
import style0 from "./DataVisual.vue?vue&type=style&index=0&id=2d10ac88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10ac88",
  null
  
)

export default component.exports